import { TypographyVariantsOptions } from '@mui/material/styles';
import { fonts } from './tokens';

/** Body, labels and buttons. */
export const fontFamilyBody = [
  'Inter',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
].join(',');

/** Headlines and card titles. */
export const fontFamilyDisplay = fonts.display;

/** Metadata — counts, sizes, timestamps, status text. */
export const fontFamilyMono = fonts.mono;

/**
 * Two families, split by job.
 *
 * `h1`–`h4` are the display voice: Oxanium, angular and tightly tracked.
 * `h5`/`h6` stay on Inter because they are used as UI labels rather than as
 * headlines — 33 of the app's 43 heading usages are `h6`, mostly card and
 * dialog titles that should read as chrome, not as a poster.
 *
 * Sizes are unchanged from before the display face landed. The design composes
 * much larger (its `h1` is 76px), but adopting that scale would reflow every
 * existing screen, so the family, weight and tracking come across and the scale
 * stays put.
 */
export const typography: TypographyVariantsOptions = {
  fontFamily: fontFamilyBody,
  h1: {
    fontFamily: fontFamilyDisplay,
    fontWeight: 800,
    fontSize: 40,
    lineHeight: 1.05,
    letterSpacing: '-0.035em',
  },
  h2: {
    fontFamily: fontFamilyDisplay,
    fontWeight: 800,
    fontSize: 32,
    lineHeight: 1.05,
    letterSpacing: '-0.03em',
  },
  h3: {
    fontFamily: fontFamilyDisplay,
    fontWeight: 700,
    fontSize: 28,
    lineHeight: 1.1,
    letterSpacing: '-0.03em',
  },
  h4: {
    fontFamily: fontFamilyDisplay,
    fontWeight: 700,
    fontSize: 24,
    lineHeight: 1.15,
    letterSpacing: '-0.02em',
  },
  h5: {
    fontWeight: 500,
    fontSize: 20,
    lineHeight: 1.2,
  },
  h6: {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: 1.2,
  },
  subtitle1: {
    fontSize: 16,
    lineHeight: 1.5,
  },
  subtitle2: {
    fontSize: 14,
    lineHeight: 1.5,
  },
  body1: {
    fontSize: 16,
    lineHeight: 1.5,
  },
  body2: {
    fontSize: 14,
    lineHeight: 1.5,
  },
  button: {
    fontWeight: 500,
    fontSize: 14,
    textTransform: 'none',
  },
  caption: {
    fontSize: 12,
    lineHeight: 1.5,
  },
  overline: {
    fontSize: 12,
    textTransform: 'uppercase',
    fontWeight: 500,
  },
};
